<template>
  <default />
</template>

<script>
  import Default from './default';
  import store from './stores.js';

  export default {
    name: 'InterviewTalentq',

    components: {
      Default
    },

    mixins: [store]
  };
</script>
